export const E_COMMERCE_ID = -1;
//# sourceMappingURL=goal.js.map